import React, { Component } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

class ShareChild extends Component {
  constructor(props) {
    super(props);

    this.state = {
      linkCopied: false,
      linkCopiedClickCount: 0,
      shakeText: false,
    };
  }

  shakeText(time = 800) {
    this.setState({ shakeText: true }, () => {
      setTimeout(
        () => {
          this.setState({ shakeText: false });
        },time);
    });
  }

  renderText() {
    if (this.state.linkCopied) {
      return (
        <span
          className={`child-link_text__copied child-link_text ${
            this.state.linkCopiedClickCount > 1 && this.state.shakeText === true ? "previously-copied" : ""
          }`}
          tabIndex="0"
        >
          <FontAwesomeIcon icon={faCheckCircle} /> link copied
        </span>
      );
    } else {
      return (
        <span
        className="child-link_text"
        tabIndex="0">
          <FontAwesomeIcon icon={faCopy} /> copy link
        </span>
      );
    }
  }

  render() {
    const price = this.props.price;
    return (
      <div className="copy-link">
        <CopyToClipboard
          text={this.props.linkToCopy}
          onCopy={() => {
            this.shakeText(800);
            this.setState((prevState) => {
              return {
                linkCopied: true,
                linkCopiedClickCount: prevState.linkCopiedClickCount + 1,
              };
            });
          }}
        >
          {this.renderText()}
        </CopyToClipboard>
      </div>
    );
  }
}

export default ShareChild;
